export { default } from './PricePlaceholder';
